import * as React from 'react';
import {IState as CommonState} from "../../common/State";
import {RouteComponentProps} from "react-router";
import {ListBreadcrumb} from "./Data";
import EmailTemplateFilter from './filter/EmailTemplateFilter';
import _, { get } from "lodash";
import {list_key} from "../../helpers/OrderHelper";
import {ListForm, ListHeader, ListingLayout} from "../../layout/Listing";
import {actionButton, Icons, ShowRecords, ActionLink, ExportButton} from "../../common";
import {humanifyDate} from "../../helpers/UserHelper";
import { NotificationLogModel } from '../../model';
import { LogInfoModal } from './modal/LogInfoModal';


declare var window:any;

interface IState extends CommonState {
  show: boolean;
  log: NotificationLogModel
}

export class NotificationLogs extends React.Component<RouteComponentProps, IState> {
    state: IState;
    records:React.RefObject<ShowRecords> = React.createRef();

    shouldComponentUpdate(nextProps: Readonly<RouteComponentProps>, nextState: Readonly<IState>, nextContext: any): boolean {
      
        return  this.state !== nextState;
         
     }

    createMarkup =(content: string) => {
        return { __html: content };
    }

    showContent = (data: NotificationLogModel, index: number) => {
      let cols = [];
      cols.push(...[
        <td key={index}>{this.records.current.checkbox(data.id)}</td>,
        this.records.current.createdTd("system_notification", data.system_notification.title),
        this.records.current.createdTd("user", data.user.name),
        this.records.current.createdTd("subject", data.subject),
        this.records.current.createdTd("content", data.content),              
        this.records.current.createdTd("created_at", humanifyDate(data.created_at)),
        this.records.current.createdTd("action", () => {
          return <div>
            <ActionLink scope={'system-notifications.index'} to={`#`}  
              onClick={e => this.setState({show: true, log: data})}
              title={"View notification"} >
              <i className={Icons.view} />
            </ActionLink>
          </div>;
        })
      ]);
      cols = _.compact(cols);
        return (
            <tr key={list_key(data.id)}>{cols}</tr>
        );
    }

  
    filterRecords = (data?: any) => {
        if( this.records && this.records.current !== null){
          if(data !== undefined){
            this.records.current.setFormFields(data);
          }else {
            this.records.current.setFormFields();
          }
        }
      }

    render() {
        return (
            <div>

              <ListingLayout breadcrumb={ListBreadcrumb}>
                <ListHeader title={"Notification Logs"} icon={Icons.email} >
                  <ExportButton records={this.records} fileName={"notification-log"}/>
                  &nbsp;                  
                </ListHeader>

                <ListForm
                  form={<EmailTemplateFilter  getResults={this.filterRecords} />}
                  table={(
                    <ShowRecords
                      url={"/settings/notification-logs"}
                      showRecords={this.showContent}
                      ref={this.records}
                      isNeedAction={true}
                      showCheckbox={false}
                      actionButtons={actionButton({buttons: ["Delete"], records: this.records, url: "settings/notification-logs/bulk-action", module: 'notification-logs' })}
                      //rowActions={this.rowActionButtons}
                    />
                  )}
                />

                <LogInfoModal
                  show={get(this.state, "show", false)}
                  onHide={() => this.setState({show: false})}
                  log={get(this.state, "log", {})}
                />
              </ListingLayout>

                
            </div>
        )
    }
}
